import { useMatch } from 'react-router';
import { useLoginInfo } from '../../react-hooks/useLoginInfo';
import { hasPermission } from '../../lib/apollo';
import { UserPermission } from '../../lib/graphql.document';
import Scale from '../../icons/scale.svg?svgr';
import Pin from '../../icons/pin.svg?svgr';
import { PostScores } from './types';
import { ROUTES } from '../../lib/ROUTES';

interface PostScoreProps {
  scores: PostScores | undefined;
}

const PostScore = ({ scores }: PostScoreProps) => {
  const { user } = useLoginInfo();

  const isOnBlogs = Boolean(useMatch(ROUTES.BLOGS.$path()));
  const isOnMain = Boolean(useMatch(ROUTES.ROOT.$path()));
  const isOnStream = isOnBlogs || isOnMain;

  const formatNumber = (value: number | null | undefined, increasedPrecision?: boolean): string =>
    (value ?? 0).toFixed(increasedPrecision ? 6 : 2);

  const shouldShow = isOnStream && user && hasPermission(user.permissions, UserPermission.CreateAdvertisement);

  const isPinned = !scores;
  const icon = isPinned ? <Pin width={16} height={16} /> : <Scale width={16} height={16} />;

  const tooltip = isPinned
    ? 'Нет веса (пост закреплен или получен из списка без весов)'
    : [
        `Score: ${formatNumber(scores.totalScore, isOnBlogs)}`,
        `Freshness: ${formatNumber(scores.publishDateScore, isOnBlogs)}`,
        `CTR: ${formatNumber(scores.internalViewsScore, isOnBlogs)} (${scores.internalViewsCount})`,
      ].join(' | ');

  return shouldShow && tooltip ? (
    <span title={tooltip} className="flex items-center text-blood">
      {icon}
    </span>
  ) : null;
};

export { PostScore };
